// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.manager[data-v-6bfe4178] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    margin-top: 1.5em !important;\n    position: sticky;\n    top: 0;\n}\n.manager .title[data-v-6bfe4178] {\n    padding-left: 20px;\n}\n.manager .filter[data-v-6bfe4178] {\n}\n.manager .actions[data-v-6bfe4178] {\n}\n", ""]);
// Exports
module.exports = exports;
